import { ApolloError } from '@apollo/client';
import * as Sentry from '@sentry/react';
import { formatGqlError } from 'common/GqlUtilities';
import React, { useMemo } from 'react';
import { isProdEnvironment, isStagingEnvironment } from 'src/shared/utils/EnvironmentUtilities';

interface IProps {
  error: ApolloError | undefined;
  message?: string;
}

export const NetworkingError: React.FC<IProps> = ({ error, message }: IProps) => {
  const isStagingOrProd = useMemo(() => isStagingEnvironment() || isProdEnvironment(), []);
  React.useEffect(() => {
    if (error && isStagingOrProd) {
      try {
        Sentry.captureException(error);
      } catch (e) {
        console.error(e);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [(error && error.toString()) || '']);

  // Always show the detailed error in non-prod like environments:
  const messageToShow = useMemo(
    () => (!isStagingOrProd && error ? `${formatGqlError(error)}\n\n${message}` : message),
    [isStagingOrProd, message, error]
  );

  return <h5>{messageToShow || (error && formatGqlError(error))}</h5>;
};
